import React from 'react'
import { connect } from 'react-redux'
import { FormHelperText } from '@material-ui/core'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({
    dateRangeToggled: state.campaign.addOrEdit.campaign.dateRange,
    startDate: state.campaign.addOrEdit.campaign.fields.start_date,
    endDate: state.campaign.addOrEdit.campaign.fields.end_date,
  }),
  null
)(({ error, dateRangeToggled, startDate, endDate }) => (
  <FormHelperText error={Boolean(error)}>
    {error
      ? error
      : dateRangeToggled
      ? startDate && endDate
        ? language.campaign.helperText.sendRange
        : startDate
        ? language.campaign.helperText.infiniteRange
        : endDate
        ? language.campaign.helperText.endRange
        : language.campaign.helperText.indefiniteRange
      : language.campaign.helperText.indefiniteRange}
  </FormHelperText>
));
